<footer>
    <mat-divider></mat-divider>
    <div class="footer-container">
        <div class="left-container">
            <a mat-button class="link" href="https://www.tapgo.ch" target="#">{{ 'HOME' | translate }}</a>
            <a mat-button class="link" href="https://www.tapgo.ch" target="#">{{ 'COMPANY' | translate }}</a>
            <a mat-button class="link" href="https://www.tapgo.ch" target="#">{{ 'PORTFOLIO' | translate }}</a>
            <a mat-button class="link" href="https://www.tapgo.ch" target="#">{{ 'BLOG' | translate }}</a>

        </div>

        <span class="spacer"></span>
        <div class="right-container">
            <mat-icon color="primary">copyright</mat-icon>
            <span>2025,{{ 'Powered by' | translate }} <a href="https://www.tapgo.ch" target="#" class="logo"> {{ 'Tapgo'
                    | translate }}</a></span>
        </div>
    </div>

</footer>